'use client';

import { InputHTMLAttributes, useEffect, useState } from 'react';
import { CustomInput } from '@/ui/common/Inputs/CustomInput';

type TTicketTextOption = InputHTMLAttributes<HTMLInputElement> & {
    name: string;
    isRequired: boolean;
    isTouched?: boolean;
    selected?: string;
    onInputOption: (value: string) => void;
};

export const TicketTextOption = ({
    isRequired,
    onInputOption,
    isTouched,
    selected,
    ...props
}: TTicketTextOption) => {
    const [error, setError] = useState(!!isTouched);

    useEffect(() => {
        if (isRequired && isTouched && !selected) {
            setError(true);
        }
    }, [isRequired, isTouched, selected]);

    return (
        <CustomInput
            fieldClassName={`placeholder:text-gray-3 h-[50px] bg-white p-[14px_24px_14px_30px] dark:bg-blue-main ${
                error ? 'border-state-error dark:border-state-error' : ''
            }`}
            onBlur={(e) => {
                if (isRequired) setError(!(e.target as HTMLInputElement).value.trim());
            }}
            onInput={(e) => {
                const value = (e.target as HTMLInputElement).value.trim();
                onInputOption(value);

                if (isRequired) setError(!value);
            }}
            {...props}
        />
    );
};
